module.exports = __webpack_public_path__ + "img/柚子6.cba7855f.png";